import { createSlice } from "@reduxjs/toolkit";
import { getInstagramAccountList } from "./ThunkActions";
import { iInstagramAccountState, REDUCER_NAME } from "./Types";

const initialState: iInstagramAccountState = {
  isLoading: false,
  instagramAccountList: [], 
  errorMessage: null,
};

export const InstagramAccountSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetInstagramAccountState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInstagramAccountList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getInstagramAccountList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.instagramAccountList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getInstagramAccountList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch Payment Gateway data";
        state.isLoading = false;
      });
  },
});

export const { resetInstagramAccountState } = InstagramAccountSlice.actions;
export default InstagramAccountSlice.reducer;